<template>
  <div class="h-screen loginscreen flex w-full bg-img vx-row no-gutter items-center justify-center forgotscreen">
    <div class="container">
      <vs-row class="justify-center">
        <vs-col vs-lg="9" vs-md="10" vs-sm="8" vs-xs="12" vs="12">
          <vx-card>
              <div slot="no-body" class="full-page-bg-color">
                <form data-vv-scope="addResetScope">
                  <vs-row class="vx-row no-gutter justify-center">
                      <vs-col vs-lg="5" vs-md="6" vs-sm="12" vs-xs="12">
                        <div class="vx-row loginlogoouter no-gutter justify-center">
                          <div class="loginlogo">
                            <img src="@/assets/images/logo/ilerno-logo.svg" alt="login">
                          </div>
                        </div>
                      </vs-col>
                      <vs-col vs-lg="7" vs-md="6" vs-sm="12" vs-xs="12" class="d-theme-dark-bg self-center">
                        <div class="login-tabs-container">
                          <div class="vx-card__title">
                            <h2><b>{{ customerData.customerName }}</b></h2>
                          </div>
                          <div v-if="user_name!=''" class="vx-card__title welcomtxt">
                            <h4><b>Welcome, {{user_name}} <br/> {{email}}</b></h4>

                            <div class="mb-4">
                              <vs-input name="Password" type="password" ref="Password" data-vv-name="Password"
                              v-validate="'required|min:8'" icon-no-border icon="icon icon-lock" icon-pack="feather"
                              placeholder="New Password" label="New Password" v-model="password" class="w-full"/>
                              <div v-if="errors.has('addResetScope.Password')" style="color:red;" class="invalid-feedback">{{ errors.first('addResetScope.Password') }}</div>
                            </div>
                            <div class="mb-4">
                              <vs-input name="Confirm_Password" data-vv-name="Confirm Password" type="password" v-validate="'required|min:8|confirmed:Password'" icon-no-border icon="icon icon-lock" icon-pack="feather" placeholder="Confirm Password" label="Confirm Password" v-model="password_confirmation" class="w-full"/>
                              <span class="text-danger" v-show="errors.has('addResetScope.Confirm Password')">{{ errors.first('addResetScope.Confirm Password') }}</span>
                            </div>
                            <vs-button type="border" :to="{name: 'forgot-password'}" class="px-4 w-full md:w-auto">Back</vs-button>
                            <vs-button @click="forgotPassword" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"> {{ this.$route.query.type=='WELCOME'?'Set Password':'Change Password'}}</vs-button>
                        </div>
                        <div v-else>
                          <h5 class="mb-4">This link has been expired. Please re-register your email id to receive the latest password link.</h5>
                          <vs-button type="border" :to="{name: 'forgot-password'}" class="px-4 w-full md:w-auto">Back</vs-button>
                        </div>

                        </div>
                      </vs-col>
                    </vs-row>
                </form>
              </div>
          </vx-card>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
// import allServices from "../../services/allServices";
import {ResetForgetPassword, getUserDetailsByToken, fetchCustomerDataBySubdomainAPI} from '@/api/login'
import { URLMixins } from "@/mixins/url/url-with-domain";

export default{
  mixins: [URLMixins],
  data () {
    return {

      redirectUnifiedLogin: '',
      password: '',
      password_confirmation:'',
      error: false,
      message: false,
      email: '',
      token:'',
      user_type:'',
      customer_id:'',
      user_name:'loading...',
      customerData : {
          customerId : '',
          customerName: '',
          customerDomain: ''
      },
    }
  },
  created () {
    this.fetchCustomerDataBySubdomain()
  },
  mounted () {
    //this.email = this.$route.query.email
    this.token = this.$route.query.token
    this.user_type = this.$route.query.user_type
    this.$vs.loading()

    let payload = {}
    if (this.user_type != 'USER') {
      payload = {
        client: 'client-portal',
        token:  this.token,
      }
    } else {
      payload = {
        token:  this.token,
      }
    }

    getUserDetailsByToken(payload)
    .then((res) => {
      console.log('getUserDetailsByToken: ',res.data.data)

      if (res.data.data == '' || res.data.data == null)
      {
        this.user_name = '';
        this.$vs.notify({
          title: 'Error',
          text: 'Password reset link has been expired',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false;
      }

      // staff
      if (res.data.data.first_name) {
        this.user_name = res.data.data.first_name + ' ' + res.data.data.last_name
        this.email = res.data.data.user_active_email.email
      }
      // client
      else if(res.data.data.client_users_id) {
        res.data.data.client_user
        this.user_name = res.data.data.client_user.first_name + ' ' + res.data.data.client_user.last_name
        this.email = res.data.data.client_user.email
      }

      this.$vs.loading.close()
    })
    .catch((e) => {
      console.log('err' , e)
      this.$vs.loading.close()
    })
  },
  methods : {
    async fetchCustomerDataBySubdomain () {
      this.$vs.loading({})

      this.customer_id = this.$route.query.cid
      const payload = {
        'customer_id' : this.customer_id,
      }

      await fetchCustomerDataBySubdomainAPI(payload)
        .then((response) => {
          const data = response.data.data.customerData
          console.log('fetchCustomerDataBySubdomainAPI data', data)
          this.customerData.customerId = data.id
          this.customerData.customerName = data.brand_company_name
          this.customerData.customerDomain = data.subdomain_name

          // IMPLEMENT IT
          // const path = new URL(window.origin);
          // console.log(`${path.protocol}`)
          // console.log(`${path.host}`)
          // console.log(`${subDomainName}`)
          // console.log(this.redirectUnifiedLogin)

          // setting up unified login URL
          this.redirectUnifiedLogin = this.makeUrlDomain(this.customerData.customerDomain)
          console.log('redirectUnifiedLogin', this.redirectUnifiedLogin)

          this.$vs.loading.close()
        })
        .catch((apiError) => {
          this.$vs.loading.close()
          this.showError = true
          console.log('fetchCustomerDataBySubdomainAPI err: ',apiError)
        })
        this.$vs.loading.close()
    },
    forgotPassword () {
    // const urlParams = new URLSearchParams(window.location.search)
    // this.email = this.$route.params
      const data = {
        token: this.token,
        email:decodeURIComponent(this.email),
        password:this.password,
        customer_id:this.customer_id,
        user_type:this.user_type
      }

      // check password = password_confirmation
      if ((this.password != '') && (this.password_confirmation != ''))
      {
        if (!(this.password === this.password_confirmation))
        {
          this.$vs.notify({
              title: 'Error',
              text: 'The Password & Confirm Password does not match',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            return;
        }
      }
      else
      {
        this.$vs.notify({
            title: 'Warning',
            text: 'The Password & Confirm Password fields are required',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          return;
      }

      // general validation
      this.$validator.validateAll('addResetScope').then(valid => {
        if (valid) {
          this.sendForgotData(data)
        } else {
          this.$vs.notify({
            title: 'Warning',
            text: 'Enter valid data',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      })

    },

    async sendForgotData (data) {
      const payload = data

      try {
        this.$vs.loading({
          text: 'Setting password, Please wait...'
        })
        await ResetForgetPassword(payload)
        //
        this.$vs.notify({
          title: 'Success',
          text: 'Password updated successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.$vs.loading.close()
        // Redirect after a 1-second delay
        setTimeout(() => {
          console.log('redirectUnifiedLogin', this.redirectUnifiedLogin)
          window.location.href = this.redirectUnifiedLogin;
        }, 1000);

      } catch (e) {
        this.$vs.loading.close()
        console.log('sendForgotData: ', e)
        this.$vs.notify({
          title: 'Error',
          text: 'Link is expired, Please try again',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

      }
    }

  }


}
</script>

<style lang="scss">
@import "@/assets/scss/login.scss";
</style>
